import { writable } from 'svelte/store'

import type { AccTemplates } from './types'



const store = writable([] as AccTemplates)

export { store as account_templates_store }



